// Plausible custom events (same instance/site as app2: vaideo.org).
// Never send personal data: only coarse, non-identifying props.
type PlausibleFn = (event: string, opts?: { props?: Record<string, string | number> }) => void

export function track(event: string, props?: Record<string, string | number>) {
  try {
    const w = window as unknown as { plausible?: PlausibleFn }
    w.plausible?.(event, props ? { props } : undefined)
  } catch { /* analytics must never break the editor */ }
}
